import React from 'react';
import { Flex, List, Modal, Form, Input, message } from 'antd';
import { UpOutlined, DownOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import SwitchShop from '../shop/switch-shop';


export default () => {
    const [list, setList] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [form] = Form.useForm();
    const [isEdit, setIsEdit] = React.useState(false);

    React.useEffect(() => {
        loadCateList();
    }, []);

    const loadCateList = () => {
        getCateList().then(res => {
            setList(res);
        })
    }

    const getCateList = async () => {
        let response = await fetch(`/api/category/list`);
        let result = await response.json();

        if(result && result.success) { 
            return result.data;
        }
        return [];
    }

    const onChangeCate = (content) => {
        if(content) {
            setIsEdit(true);
            form.setFieldsValue({
                title: content.title,
                cateId: content.cateId,
            });
        } else {
            setIsEdit(false);
            form.resetFields();
        }
        setOpen(true);
    }

    const onDelete = async (cateId) => {
        Modal.confirm({
            title: '确定删除该分类吗？',
            content: '删除后不可恢复',
            okText: '确定',
            cancelText: '取消',
            onOk: async () => {
                let response = await fetch(`/api/category/del`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        cateId
                    }),
                });

                let result = await response.json();

                if(result && result.success) {
                    message.success('删除成功');
                    setTimeout(() => {
                        loadCateList();
                    }, 1000);
                } else {
                    message.error(result.data);
                }
            },
        });
    }

    const onSubmit = () => {
        form.validateFields().then(async values => {
            console.log(values);
            const url = isEdit ? `/api/category/edit` : `/api/category/create`;

            let response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(values),
            });
            let result = await response.json();

            if(result && result.success) {
                message.success(`${isEdit ? '编辑' : '添加'}成功`);
                setOpen(false);
                setTimeout(() => {
                    loadCateList();
                }, 1000);
            } else {
                message.error(result.data);
            }
        }).catch(err => {
            console.log(err);
        })
    }

    return (
        <>
            <SwitchShop />
            <h2>分类管理</h2>
            <Modal destroyOnClose title={`${isEdit ? '编辑' : '添加'}类目`} open={open} onOk={onSubmit} onCancel={() => setOpen(false)}>
                <Form form={form}>
                    <Form.Item name="title" label="类目名称" rules={[{ required: true, message: '请输入类目名称' }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name='cateId' hidden>
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
            <List
                className="demo-loadmore-list"
                // loading={initLoading}
                itemLayout="horizontal"
                // loadMore={loadMore}
                bordered
                dataSource={list}
                renderItem={(item, index) => (
                    <List.Item
                        key={item}
                        actions={[<a key="edit" onClick={() => onChangeCate(item)}>编辑</a>, <a key="more" onClick={() => onDelete(item.cateId)}>删除</a>]}
                    >
                        <Flex gap={10}>
                            {/* <Flex gap={10} style={{fontSize: 16}}>
                                {index > 0 ? <UpOutlined /> : <MinusOutlined />}
                                {index < list.length - 1 ? <DownOutlined /> : <MinusOutlined />}
                            </Flex> */}
                            <div>{item.title}</div>
                        </Flex>
                    </List.Item>
                )}
            />
            <a onClick={() => onChangeCate()}><PlusOutlined /> 添加分类</a>
        </>
    )
}